module.exports = __webpack_public_path__ + "media/ai-background.765af61f.mp4";